/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterStoneCut_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_viewer">;
    readonly " $refType": "SbRespRefineMenuFilterStoneCut_viewer";
};
export type SbRespRefineMenuFilterStoneCut_viewer$data = SbRespRefineMenuFilterStoneCut_viewer;
export type SbRespRefineMenuFilterStoneCut_viewer$key = {
    readonly " $data"?: SbRespRefineMenuFilterStoneCut_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterStoneCut_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterStoneCut_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'fab7eb5574a476fe0f59bb7094fd7d77';
export default node;
